import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
      encapsulation: ViewEncapsulation.None,
  
})
export class AlertsComponent implements OnInit {

  public ads: any[] = [];

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
    public _translateService: TranslateService,
      private toastr : ToastrService,
               private translate: TranslateService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public messages: any = {};
 public pages  : any
  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

  ngOnInit(): void {
    // this.apisService.notifications().subscribe({ 
    //   next:(response:any)=> { 
    //     this.ads = response.data || [] ;
    //     console.log('response is' , this.ads)
    //   }, 
    //   error:(err)=> { 
    //     console.log('error in fetching', err)
    //   }
    // })
       this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this._translateService.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

           this.getTags();
  }

getTags() {
  this.apisService.notifications().subscribe({
    next: (response: any) => {
      // Access notifications inside response.data.data
      this.pages = response.data.data || [];
      this.totalItems = this.pages.length;
      console.log("Notifications:", this.pages);
    },
    error: (error: any) => {
      console.log("Error fetching notifications:", error);
    }
  });
}


   private setDatatableMessages() {
    this.messages = {
      totalMessage: this._translateService.instant('MENU.DASHBOARD.total')
    };
  }

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.ads = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  confirmDelete(id: any) {
  Swal.fire({
    title: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this._translateService.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this._translateService.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.deleteProduct(id);
    }
  });
}
truncateText(text: string, limit: number = 20): string {
  if (!text) return '';
  if (text.length <= limit) return text;
  return text.substr(0, limit) + '...';
}
     /*----------  deleting   ----------*/
 deleteProduct(id:any){ 
  this.apisService.DeleteNotifications(id).subscribe({
    next: (response: any) => {
    this.toastr.success(
        this._translateService.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );      this.getTags();
    },
    error: (error: any) => {
      console.log(error);
   this.toastr.error(
        this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );    }
  }
    
  )
 } 


 showInfo(row: any) {
  Swal.fire({
    title: this._translateService.instant('MENU.DASHBOARD.details'),
    html: `
      <div style='text-align:left;direction:${this._translateService.currentLang === 'ar' ? 'rtl' : 'ltr'}'>
        <p><strong>ID:</strong> ${row.id}</p>
        <p><strong>${this._translateService.instant('MENU.DASHBOARD.title')}:</strong> ${row.title || '-'}</p>
        <p><strong>${this._translateService.instant('MENU.DASHBOARD.message')}:</strong> ${row.message || '-'}</p>
      </div>
    `,
    icon: 'info',
    confirmButtonText: this._translateService.instant('MENU.DASHBOARD.okay')
  });
}

viewDetails(productId: number) {
  this.router.navigate(['/alerts-details', productId]);
}


}
